import HttpClient, {
  IResponseModel,
  IResponseModelWithPagination,
  TDataWithPagination,
} from "../HttpClient";

import { ISavedFilter } from "@tedivo/tvd-api-models";

const savedFiltersBaseUrl = "savedFilters";

const ApiKeysService = {
  getAll: async (
    scope: string,
  ): Promise<IResponseModelWithPagination<ISavedFilter[]>> => {
    const client = new HttpClient();
    return await client.request<TDataWithPagination<ISavedFilter[]>>({
      method: "GET",
      url: `${savedFiltersBaseUrl}?scope=${scope}`,
    });
  },

  get: async (id: string): Promise<IResponseModel<ISavedFilter>> => {
    const client = new HttpClient();
    return await client.request<ISavedFilter>({
      method: "GET",
      url: `${savedFiltersBaseUrl}/${id}`,
    });
  },

  delete: async (id: string): Promise<IResponseModel<unknown>> => {
    const client = new HttpClient();
    return await client.request<unknown>({
      method: "DELETE",
      url: `${savedFiltersBaseUrl}/${id}`,
      data: undefined,
    });
  },

  create: async (
    data: ISavedFilter,
  ): Promise<IResponseModel<ICreateOutput>> => {
    const client = new HttpClient();
    return await client.request<ICreateOutput>({
      method: "PUT",
      url: savedFiltersBaseUrl,
      data,
    });
  },

  update: async (
    data: ISavedFilter,
  ): Promise<IResponseModel<ICreateOutput>> => {
    const client = new HttpClient();
    return await client.request<ICreateOutput>({
      method: "PUT",
      url: savedFiltersBaseUrl,
      data,
    });
  },
};

export default ApiKeysService;

interface ICreateOutput {
  id: string;
}
